module.exports = __webpack_public_path__ + "static/media/kz.7776ef82.png";